<template lang="pug">
include /../../s-pug/mixin-icon
div
   .Underlay._fixed._alpha-80._radius._cursor-default
   form.EditSlideout(@submit.prevent="$emit('done', {ref, companyData})" novalidate="true")
      //- ------------------------------------------------------------------------  
      //- Heading
      //- ------------------------------------------------------------------------  
      ._px075._py075._flex._flex-alignItemsCenter._boxShadow._z50
         ._flex-1
            ._c-grey-700._fs-3._bold {{heading}}
         div
            button.Btn.Btn--white._p025(style="width: 40px; height: 40px" type="button" @click="$emit('cancel', {ref})")
               +icon({grow: true, name: "icon-x"})._c-grey-800
      //- ------------------------------------------------------------------------
      //- Body
      //- ------------------------------------------------------------------------
      ._overflowScrollY._customScrollBars._flex-1
         ._px075._py1._mx-auto(style="max-width: 700px")
            //- ------------------------------------------------------------------------
            //- Type : info
            //- ------------------------------------------------------------------------
            mixin sectionOverviewGroup({first, last} = {})
               div(class=first ? '_pb4' : '_py4' class=last ? '' : '_borderBottom _borderColor-grey-050 _border-width3')&attributes(attributes): block
            mixin sectionOverviewHeading({inputLabelConnected} = {})
               ._fs-3._c-grey-900(style="font-weight: 700" class=inputLabelConnected ? 'InputLabel-value' : '_mb075')&attributes(attributes): block
            ._mb2(v-if="ref === 'ref-info'")
               //- attr : Logo
               +sectionOverviewGroup({first: true})
                  label.InputLabel--connected
                     +sectionOverviewHeading({inputLabelConnected: true}): | Company logo
               //- attr : Tagline
               +sectionOverviewGroup({last: true})
                  label.InputLabel--connected
                     input.Input.Textarea._fs-1._lineHeight--1dot4._textarea-resizeNone(v-model=`companyData.tagline` type="text")
                     +sectionOverviewHeading({inputLabelConnected: true}): | Company tagline
               //- attr : Summary
               +sectionOverviewGroup({last: true})
                  label.InputLabel--connected
                     textarea#js-focusTarget.Input.Textarea._fs-1._lineHeight--1dot4._textarea-resizeNone(v-model=`companyData.summary` style="min-height: 140px")
                     +sectionOverviewHeading({inputLabelConnected: true}): | Company summary
      //- ------------------------------------------------------------------------
      //- Footer
      //- ------------------------------------------------------------------------
      ._flex._px075._py075._boxShadow._z50
         button.Btn.Btn--sm.Btn--greyDk._ml-auto(type="button" @click="$emit('cancel', {ref})") Cancel
         button.Btn.Btn--sm.Btn--green._px3._ml05(type="submit") Done
</template>
<style lang="sass">
.EditSlideout
   z-index: 500
   // max-width: 650px
   max-width: 1100px
   // left: $s-05
   width: 100%
   top: $s-05
   bottom: $s-05
   right: $s-05
   position: fixed
   background-color: white
   border-radius: $radius
   // +px($s-075)
   // +py($s-075)
   cursor: default
   display: flex
   flex-direction: column
.EditPanel-primaryContent
   line-height: 1.55
   p 
      margin-bottom: $s-05
   ol
      list-style: decimal
      list-style-type: decimal
   ul
      list-style: disc
      list-style-type: disc
   ol, ul
      list-style-position: outside
      margin-bottom: $s-1
      padding-left: $s-2
      li p
         display: inline
      li
         margin-top: $s-05

</style>

<script>
// modules
import { cloneDeep } from 'lodash'
import MarkdownIt from 'markdown-it'
const md = new MarkdownIt()
// components
import SlideToggle from '~/components/SlideToggle'
export default {
   name: 'Panel',
   props: {
      panelProps: Object,
   },
   components: {
      SlideToggle,
   },
   data() {
      return {
         ...this.panelProps,
      }
   },
   methods: {},
}
</script>
